import React, { useState, useEffect } from 'react';
import { Typography, Table, Select, message, Form, Descriptions, Divider, Space, Row, Col, Tabs } from 'antd';
import useWebPost from '../../utils/useWebPost';

import FullHeightLayout from '../../components/FullHeightLayout';
import { useNavigate, useParams } from 'react-router-dom';
import renderFileList from '../../components/renderFileList';

const { Text } = Typography;
const { Option } = Select;

const ReceiptDetails = ({ item }) => {
    const { id } = useParams();
    const webPost = useWebPost();
    const [data, setData] = useState(null);
    const [szList, setszList] = useState(null);

    useEffect(() => {
        setszList(null);
        if (item) {
            setData(item);
        } else {
            async function getXx(s) {
                const res = await webPost('getCwRecBySn', { id: s });
                if (res) {
                    setData(res);
                }
            }
            if (id) {
                getXx(id);
            }
        }
        return undefined;
    }, [id, item]);

    useEffect(() => {
        const fxs = async () => {
            if (data) {
                const res = await webPost('getLkzcList', { id: data.id });
                if (res) {
                    if(res.length===0){
                        setszList(null);
                    }else{
                        setszList(res);
                    }
                }
            }
        };
        fxs();
        return undefined;
    }, [data]);

    if (data === null) return (<></>);
    const {
        receipt_company,
        receipt_account,
        maker_name,
        make_date,
        income_type,
        settlement_method,
        payer_name,
        payer_account,
        payer_bank,
        km, kmmc,
        remark, remark1, remark2,
        this_receipt_amount,
        xmmc,
        contract_amount,
        invoiced_amount,
        received_amount,
        attachment,
    } = data;
    return (
        <FullHeightLayout
            headerContent={null}
            footerContent={null}
        >
            <div style={{ padding: '6px 12px', background: '#fff' }}>
                {/* 收款方信息 */}
                <Divider orientation="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                    收款方信息
                </Divider>
                <Descriptions
                    layout="vertical"
                    column={{ xs: 1, sm: 2, md: 3 }}
                    bordered
                    size="middle"
                    style={{ marginBottom: 24 }}
                >
                    <Descriptions.Item label="收款单位">{receipt_company}</Descriptions.Item>
                    <Descriptions.Item label="收款账号">{receipt_account}</Descriptions.Item>
                    <Descriptions.Item label="制单人">{maker_name}</Descriptions.Item>
                    <Descriptions.Item label="制单日期">{make_date}</Descriptions.Item>
                </Descriptions>

                {/* 付款方信息 */}
                <Divider orientation="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                    付款方信息
                </Divider>
                <Descriptions
                    layout="vertical"
                    column={{ xs: 1, sm: 2, md: 3 }}
                    bordered
                    size="middle"
                    style={{ marginBottom: 24 }}
                >
                    <Descriptions.Item label="收入类别">{income_type}</Descriptions.Item>
                    <Descriptions.Item label="结算方式">{settlement_method}</Descriptions.Item>
                    <Descriptions.Item label="付款户名">{payer_name}</Descriptions.Item>
                    <Descriptions.Item label="付款账号">{payer_account}</Descriptions.Item>
                    <Descriptions.Item label="付款银行">{payer_bank}</Descriptions.Item>

                    {/* 费用科目展示逻辑 */}
                    <Descriptions.Item label="费用科目">
                        {km && (
                            <Space>
                                <Text code>{km}</Text>
                                <Text type="secondary">
                                    {kmmc}
                                </Text>
                            </Space>
                        )}
                    </Descriptions.Item>

                    <Descriptions.Item label="备注" span={3}>
                        {remark || '-'}
                    </Descriptions.Item>
                </Descriptions>

                {/* 金额与项目信息 */}
                <Divider orientation="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                    业务明细
                </Divider>
                <Descriptions
                    layout="vertical"
                    column={{ xs: 1, sm: 2, md: 3 }}
                    bordered
                    size="middle"
                >
                    <Descriptions.Item label="本次收款金额">
                        <Text strong type="success">¥ {this_receipt_amount?.toLocaleString()}</Text>
                    </Descriptions.Item>
                    <Descriptions.Item label="项目名称">{xmmc}</Descriptions.Item>
                    <Descriptions.Item label="合同总额">¥ {contract_amount?.toLocaleString()}</Descriptions.Item>
                    <Descriptions.Item label="已开票金额">¥ {invoiced_amount?.toLocaleString()}</Descriptions.Item>
                    <Descriptions.Item label="已来款金额">¥ {received_amount?.toLocaleString()}</Descriptions.Item>
                </Descriptions>

                {szList && <Table dataSource={szList} footer={null} pagination={false} columns={[
                    { title: '说明', dataIndex: 'ps' },
                    { title: '金额', dataIndex: 'amount' },
                    { title: '账号', dataIndex: 'account' },
                ]} ></Table>
                }

                {/* 附件展示 */}
                {attachment && attachment.length > 0 && (
                    <>
                        <Divider orientation="left" style={{ marginTop: 24 }}>附件</Divider>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
                            {renderFileList(attachment)}
                        </div>
                    </>
                )}
                {remark1 && (<>
                    <Divider orientation="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                        审核备注
                    </Divider>
                    <Descriptions.Item label="审核备注" style={{ color: 'green' }}>
                        {remark1}
                    </Descriptions.Item>
                </>
                )}
                {remark2 && (<>
                    <Divider orientation="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                        财务审核备注
                    </Divider>
                    <Descriptions.Item label="审核备注" style={{ color: 'green' }}>
                        {remark2}
                    </Descriptions.Item>
                </>
                )}
            </div>
        </FullHeightLayout >
    );
};

export default ReceiptDetails;